module.exports = {
  apiKey: "AIzaSyDcLEJZnfWG0s6bGgmts29W0uail30kB8M",
  authDomain: "librate-ui.firebaseapp.com",
  databaseURL: "https://librate-ui.firebaseio.com",
  projectId: "librate-ui",
  storageBucket: "librate-ui.appspot.com",
  messagingSenderId: "477582951088",
  appId: "1:477582951088:web:50ebf2c04971ed6c"
}